import React from 'react';
import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { Box, ButtonV2 } from '@withjoy/joykit';
import { StyledLink, StyledDivider, StyledDialogFooter, StyledFlex } from './DialogFooter.styles';
import { ButtonProps } from './types';

export const DialogFooter: React.FC<ButtonProps> = ({
  isLoading,
  primaryButton,
  secondaryButton,
  tertiaryButton,
  handlePrimary,
  handleSecondary,
  handleTertiary,
  hideDivider,
  paddingX,
  primaryButtonProps,
}) => {
  const hasTertiaryButton = tertiaryButton && handleTertiary;
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });

  return (
    <>
      {!hideDivider && <StyledDivider />}
      <StyledDialogFooter
        alignItems="center"
        justifyContent={hasTertiaryButton ? 'space-between' : 'flex-end'}
        isMobile={isMobile}
        paddingX={paddingX ? paddingX : [6, null, 8]}
        paddingTop={6}
        paddingBottom={3}
      >
        {hasTertiaryButton && (
          <StyledFlex isMobile={isMobile}>
            <Box>
              <StyledLink
                component="button"
                intent="secondary"
                underline="none"
                fill={true}
                isTertiary
                disabled={isLoading}
                onClick={handleTertiary}
              >
                {tertiaryButton}
              </StyledLink>
            </Box>
          </StyledFlex>
        )}
        <StyledFlex isMobile={isMobile}>
          {secondaryButton && handleSecondary && (
            <Box>
              <StyledLink
                component="button"
                intent="secondary"
                underline="none"
                fill={true}
                disabled={isLoading}
                marginRight={['auto', null, 5]}
                onClick={handleSecondary}
              >
                {secondaryButton}
              </StyledLink>
            </Box>
          )}
          {primaryButton && handlePrimary && (
            <ButtonV2
              {...primaryButtonProps}
              marginBottom={isMobile ? 5 : undefined}
              minWidth="8.25rem"
              disabled={isLoading}
              loading={isLoading}
              onClick={handlePrimary}
            >
              {primaryButton}
            </ButtonV2>
          )}
        </StyledFlex>
      </StyledDialogFooter>
    </>
  );
};
